/* eslint-disable */

export const _tableHeaderLearnerReports = [
    { id: 1, title: "Learner Name", property: "Name" },
    { id: 2, title: "Enrolled", property: "Enrolled" },
    { id: 3, title: "Completed", property: "Completed" },
    { id: 4, title: "In Progress", property: "InProgress" },
    { id: 5, title: "Yet to Start", property: "NotStarted" }
];

export const _tableHeaderLearnerDetails = [
    { id: 1, title: "Courses/LPs", property: "CourseName" },
    { id: 2, title: "Type", property: "Type" },
    { id: 3, title: "Enrollment Date", property: "EnrollmentDate" },
    { id: 4, title: "Due Date", property: "DueDate" },
    { id: 5, title: "Completion Date", property: "CompletionDate" },
    { id: 6, title: "Progress", property: "Progress" },
    { id: 7, title: "Status", property: "Status" }
];
